import { Box, TextNew } from '@jfs/ui-new'
import { styles } from './styles'

const PayoutsLink = () => {
  return (
    <Box {...styles.container}>
      <Box {...styles.flexRowView}>
        <TextNew title={'Payout Links'} {...styles.titleText} />
      </Box>
    </Box>
  )
}

export default PayoutsLink
